<template>
  <div>
    <header class="header_shadow">
      <div class="shadow-home" />
      <!-- Navigation bar of the header section -->
      <NavHeader />
      <!-- below the nav bar -->
    </header>
    <SearchAskCard />
  </div>
</template>

<script>
import NavHeader from '../Header/NavHeader.vue'
import SearchAskCard from './SearchAskCard.vue'
export default {
  components: {
    NavHeader,
    SearchAskCard,
  },
  computed: {
    description() {
      return 'MeroAdda.com allows general users to post legal questions anonymously'+
        'and get answers from verified Lawyers in Nepal for Free. MeroAdda also provides'+
        'cheaper professional services for individuals and corporate clients.'
    },
    keywords() {
      return 'Professional Services, Free legal Q&As, Company Registration and compliances, IRD Registration,'+
        'Share Lagat, Company Amendment, Annual Reporting and Filing, Rental Agreements, Service Agreements,'+
        'Contracts (personal and Professional), Design/Patent/Trademark Registration, Deregistration, Liquidation,'+
        'Social Welfare Council registration, Exim Code, Department Registration, Foreign Direct investment,'+
        'Corporate Conversions, Law related Events & trainings, Legal Technology, Tax, VAT, PAN, Lawyer, Law, Nepal'
    },
  },
  metaInfo() {
    return {
      title: `Free Q&A with Lawyers`,
      titleTemplate: '%s - MeroAdda.com ',

      meta: [
        {name: 'keywords', content: this.keywords},
        {name: 'description', content: this.description, vmid: 'description'},
        {property: 'og:title', content: 'Free Q&A with Lawyers',
          template: (chunk) => `${chunk} - MeroAdda.com`, vmid: 'og:title'},
          {property: 'og:description', content: this.description,
            template: (chunk) => `${chunk}`, vmid: 'og:description'},
      ],
    }
  },
}
</script>

<style scoped>
.input-hint{
  margin-top: 3px;
  margin-bottom: -3px;
}

label{
  margin-top: 0;
}
</style>


